import { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
// import QRCode from '../../../assets/dummyQR.svg';
import QRCode from 'react-qr-code';
import { toast } from 'react-toastify';
import CopyIcon from '../../../assets/Icon/CopyIcon';
import AuthContext from '../../../contexts/AuthContext';
import WalletInformation from '../../common/WalletInformation';
import ReceiveCashModal from '../../dialogs/receive-cash-dialog';
import SendCashModal from '../../dialogs/send-cash-dialog';
import styles from './styles.module.scss';
import WalletContext from '../../../contexts/WalletContext';
import TokenListContext from '../../../contexts/TokenListContext';

const WalletData = () => {
  const [sendCashModal, setSendCashModal] = useState(false);
  const [receiveCashModal, setReceiveCashModal] = useState(false);
  const { walletData, refetch, refetchTransactions } =
    useContext(WalletContext);
  const { userData, userRole } = useContext(AuthContext);
  const { tokenList } = useContext(TokenListContext);
  const handleCopy = () => {
    navigator.clipboard.writeText(userData?.wallet[0]?.walletAddress || '');
    toast.success('Copied to clipboard');
  };

  const initSendCash = () => {
    if (!walletData?.Balance) {
      toast.error(
        'Your token request cannot be processed as no tokens have been created yet. Please contact your administrator to generate the necessary tokens...',
      );
    } else {
      setSendCashModal(true);
    }
  };

  useEffect(() => {
    refetch();
    refetchTransactions();
  }, []);

  return (
    <>
      <SendCashModal
        open={sendCashModal}
        onClose={() => setSendCashModal(false)}
      />
      <ReceiveCashModal
        open={receiveCashModal}
        onClose={() => setReceiveCashModal(false)}
      />
      <div className={styles.wrapper}>
        <WalletInformation />
        <div className={styles.addressWrapper}>
          <div
            style={{
              height: 'auto',
              maxWidth: 64,
              width: '100%',
            }}
          >
            <QRCode
              size={256}
              style={{
                height: 'auto',
                maxWidth: '100%',
                width: '100%',
                border: '1px solid #fff',
                padding: '2px',
              }}
              value={userData?.wallet[0]?.walletAddress || ''}
              viewBox={`0 0 256 256`}
            />
          </div>
          <div>
            <h5 className={styles.title}>Wallet Address</h5>
            <p className={styles.walletID}>
              {userData?.wallet[0]?.walletAddress || 'No wallet address'}
            </p>
          </div>
          <Button variant="plain p-0" onClick={handleCopy}>
            <CopyIcon color="var(--primary)" />
          </Button>
          <div className="d-flex gap-3 ms-5">
            <Button variant="outline-light" onClick={initSendCash}>
              Send Token
            </Button>
            <Button
              title="Receive Token"
              variant="outline-light"
              onClick={() => setReceiveCashModal(true)}
            >
              Receive Token
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default WalletData;
